import { cpfMask } from '@/app/utils/cpfFormater'
import { BasicInput } from '@/view/components/BasicInput'
import { Button } from '@/view/components/ui/button'
import { ChangeEvent } from 'react'
import { useForgotPasswordController } from './useForgotPasswordController'
import { Link } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  forgotPasswordSchema,
  ForgotPasswordFormData,
} from '../components/types'

interface ForgotPasswordProps {
  onCpfSet: (cpf: string) => void
}

export const ForgotPassword = ({ onCpfSet }: ForgotPasswordProps) => {
  const methods = useForm<ForgotPasswordFormData>({
    resolver: zodResolver(forgotPasswordSchema),
    mode: 'onChange',
  })

  const { handleFormSubmit, isPending } = useForgotPasswordController({
    onCpfSet,
  })

  return (
    <FormProvider {...methods}>
      <div className="flex flex-col gap-6 text-black03">
        <div className="text-center">
          <h2 className="mb-4 text-xl font-semibold text-gray-900">
            Esqueceu sua senha?
          </h2>
          <p className="text-sm text-black03">
            Digite seu CPF abaixo para receber instruções sobre como redefinir
            sua senha.
          </p>
        </div>

        <form
          onSubmit={methods.handleSubmit(handleFormSubmit)}
          className="flex w-full flex-col gap-4"
        >
          <BasicInput
            label="CPF"
            name="cpf"
            type="text"
            placeholder="000.000.000-00"
            className="mt-1 h-11 max-w-full border-[1px] border-black04 font-medium placeholder:text-black04"
            error={methods.formState.errors.cpf?.message}
            onInput={(e) => cpfMask(e as ChangeEvent<HTMLInputElement>)}
          />

          <Button
            type="submit"
            disabled={isPending}
            className="my-4 h-14 w-full bg-primary text-lg font-bold text-white01 hover:bg-primary hover:brightness-150"
          >
            {isPending ? 'Enviando...' : 'Enviar código'}
          </Button>
          <Link className="text-center" to="/">
            Voltar para login
          </Link>
        </form>
      </div>
    </FormProvider>
  )
}
